import { type IReactionDisposer, makeAutoObservable, reaction } from 'mobx'
import { type AgentActionNote } from 'entities/AgentActions'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { EmojiAction, EnumVariantMessageField, MessageFieldStore } from 'widgets/MessageField'

export class AgentActionNoteStore {
  private readonly _note: MessageFieldStore
  private _disposeNoteReaction: IReactionDisposer | null = null

  constructor(private _model: AgentActionNote, private _entities: IEntitiesStore) {
    this._note = new MessageFieldStore(
      {
        placeholder: 'Write internal note',
        noCounter: true,
        showActionsItems: 2,
        variant: EnumVariantMessageField.Note,
        resetOnUnmount: false,
        textLimit: {
          maxLength: 255,
          message: 'Note can contain max 255 characters',
        },
        makeActions: () => [{ iconButtonComponent: <EmojiAction /> }],
      },
      this._entities
    )

    makeAutoObservable(this)

    this._disposeNoteReaction = reaction(
      () => this._note.text,
      (text) => {
        if (text !== this._model.note) this._model.sync(text)
      }
    )
  }

  syncNote = () => {
    this._note.setMessageData({
      message: this._model.note,
      attachments: [],
      isReset: false,
      isReplace: true,
      isFocus: false,
    })
  }

  dispose = () => {
    this._disposeNoteReaction?.()
  }

  get note() {
    return this._note
  }
}
